export default __webpack_public_path__ + "static/media/spiritofthebear.bc11d434.png";